module.exports = __webpack_public_path__ + "img/edge_activites_bien_etre.77da2aa6.svg";